import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
import { fileSchema, ResultFileType } from './file';
import { getPaginationResponseSchema } from './pagination';
export const buildingPackageResultSchema = z
    .object({
    id: z.string().uuid(),
    building_package_id: z.string().uuid(),
    file: fileSchema,
    type: z.nativeEnum(ResultFileType),
    updated_at: z.string().datetime(),
    created_at: z.string().datetime(),
})
    .strict()
    .transform(mapToCamelCase);
export const getBuildingPackageResultsResponseSchema = getPaginationResponseSchema(buildingPackageResultSchema);
export const buildingPackageResultsResponseSchema = z
    .array(buildingPackageResultSchema)
    .transform(mapToCamelCase);
export const createBuildingPackageResultRequestSchema = z
    .object({
    file_id: z.string().uuid(),
    type: z.nativeEnum(ResultFileType),
})
    .strict()
    .transform(mapToCamelCase);
export const getBuildingPackageResultsRequestSchema = z
    .object({
    project_id: z.number().int(),
    building_package_id: z.string().uuid(),
    page: z.union([z.number().int(), z.literal('all')]),
    page_size: z.number().int().nullish(),
    search: z.string().nullish(),
})
    .strict()
    .transform(mapToCamelCase);
